import client from 'app/client';
import {
  GetHistoryByGranularityCommand,
  GetHistoryByGranularityResponse,
} from 'api/activity-feed';

/**
 * Historique du flux d'activité d'un contrat collectif.
 * Endpoint manuel (pas encore dans le client généré) : même réponse que
 * l'historique d'un risque assuré (POST /flux-activite/risques/{id}/historique).
 */
export async function getGroupContractHistory(
  groupContractId: string,
  command: GetHistoryByGranularityCommand,
): Promise<GetHistoryByGranularityResponse> {
  const { data } = await client.post<GetHistoryByGranularityResponse>(
    `/backoffice/flux-activite/contrats-groupes/${groupContractId}/historique`,
    command,
  );
  return data;
}
